import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "",
    message: "",
    visitorsCount: 1,
    visitorDate: new Date().toISOString().split("T")[0],    
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!form.name) newErrors.name = "Full name is required";
    if (!form.phone) newErrors.phone = "Phone number is required";
    if (!form.interest) newErrors.interest = "Please select interest";

    setErrors(newErrors);

    //  stop if error
    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const res = await api({
        url: SummaryApi.createEnquiry.url,
        method: SummaryApi.createEnquiry.method,
        data: form,
      });

      if (res?.success === true || res?.data?.success === true) {
        toast.success("Requirement submitted successfully");
      }

      // ✅ success clear
      setForm({
        name: "",
        phone: "",
        email: "",
        interest: "",
        message: "",
        visitorsCount: 1,
        visitorDate: new Date().toISOString().split("T")[0],
      });

      setErrors({});

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="py-12 px-4">
      <div className="max-w-7xl mx-auto">

        {/* TITLE */}
        <h2 className="font-times text-2xl md:text-3xl mb-8 text-[#2F2F2F] text-center">
          Send Us Your Property Requirement
        </h2>

        {/* FORM */}
        <form
          onSubmit={handleSubmit}
          className="bg-white border border-[#45A3010D] p-8 rounded-xl"
        >

          {/* NAME + PHONE */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">

            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Full Name
              </label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Ex. John Doe"
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.name ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Phone Number
              </label>
              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+91 98765 43210"
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.phone ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              />
              {errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>

          </div>

          {/* EMAIL + CATEGORY */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">

            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Email Address
              </label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="john@gmail.com"
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] placeholder-[#6B7280] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Property Interest
              </label>
              <select
                name="interest"
                value={form.interest}
                onChange={handleChange}
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.interest ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              >
                <option value="">Select Interest</option>
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
                <option value="Plantation">Plantation</option>
                <option value="Home">Home</option>
              </select>
              {errors.interest && (
                <p className="text-red-500 text-xs mt-1">{errors.interest}</p>
              )}
            </div>

          </div>
          <div className="grid md:grid-cols-2 gap-6 mb-6">

            {/* VISITOR COUNT */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Visitors Count
              </label>
              <input
                type="number"
                name="visitorsCount"
                value={form.visitorsCount}
                onChange={handleChange}
                min="1"
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

            {/* VISITOR DATE */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Visitor Date
              </label>
              <input
                type="date"
                name="visitorDate"
                value={form.visitorDate}
                onChange={handleChange}
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

          </div>
          {/* MESSAGE */}
          <div className="mb-8">
            <label className="text-sm text-[#050505] mb-2 block">
              Your Message
            </label>
            <textarea
              name="message"
              rows="5"
              value={form.message}
              onChange={handleChange}
              placeholder="Tell us about your requirements..."
              className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] placeholder-[#6B7280] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#45A301] hover:bg-[#3e9202] text-white py-2.5 rounded-lg text-base font-medium transition"
          >
            {loading ? "Submitting..." : "Submit Requirement"}
          </button>

        </form>
      </div>
    </section>
  );
};

export default Contact;